import { useSingleMinigrid } from '../../../hook'

/**
 * Title of minigrid
 * @returns 
 */
export default function TitlePresenter() {
  const {singleMinigridQuery:{data}} = useSingleMinigrid()

  return (
    <>{data?.minigrid_name}</>
  )
}
